const tagAccents = {
    fontWeight: '500',
    colorScheme: {
        light: {
            primary: {
                background: '{primary.500}',
                color: '{primary.contrast.color}'
            },
            secondary: {
                background: '{surface.500}',
                color: '{primary.contrast.color}'
            },
            success: {
                background: '{green.500}',
                color: '{primary.contrast.color}'
            },
            info: {
                background: '{blue.500}',
                color: '{primary.contrast.color}'
            },
            warn: {
                background: '{yellow.500}',
                color: '{primary.contrast.color}'
            },
            danger: {
                background: '{red.500}',
                color: '{primary.contrast.color}'
            },
            contrast: {
                background: '{surface.500}',
                color: '{primary.contrast.color}'
            }
        },
        dark: {
            primary: {
                background: '{primary.500}',
                color: '{primary.contrast.color}'
            },
            secondary: {
                background: '{surface.500}',
                color: '{primary.contrast.color}'
            },
            success: {
                background: '{green.500}',
                color: '{primary.contrast.color}'
            },
            info: {
                background: '{blue.500}',
                color: '{primary.contrast.color}'
            },
            warn: {
                background: '{yellow.500}',
                color: '{primary.contrast.color}'
            },
            danger: {
                background: '{red.500}',
                color: '{primary.contrast.color}'
            },
            contrast: {
                background: '{surface.500}',
                color: '{primary.contrast.color}'
            }
        }
    }
};

// Tag "help" / aide — framboise (palette `pink`), conforme DS
const helpTag = {
    colorScheme: {
        light: {
            primary: {
                background: '{pink.50}',
                color: '{pink.600}'
            },
        },
        dark: {
            primary: {
                background: '{pink.900}',
                color: '{pink.300}'
            },
        }
    }
};

// Tag "ai" / intelligence artificielle — violet (purple)
const aiTag = {
    colorScheme: {
        light: {
            primary: {
                background: '{purple.50}',
                color: '{purple.600}'
            },
        },
        dark: {
            primary: {
                background: '{purple.900}',
                color: '{purple.300}'
            },
        }
    }
};

export { tagAccents, helpTag, aiTag };